import Styled from "styled-components";

export const SidebarContainer = Styled.div`
height: 100vh;
display: flex;
flex-direction: column;
background: #ffffff;
border-right: 1px solid #E8ECF1;
transition: width 0.25s ease;
width: ${({ collapsed }) => collapsed ? '60px' : '230px'};
min-width: ${({ collapsed }) => collapsed ? '60px' : '230px'};

/* Logo area */
.sidebar-logo {
  padding: ${({ collapsed }) => collapsed ? '16px 8px' : '16px 20px'};
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #F0F2F5;
  min-height: 56px;
  .logo-text {
    font-size: 18px;
    font-weight: 700;
    color: #1B2559;
    letter-spacing: -0.3px;
    cursor: pointer;
    user-select: none;
    .logo-text-accent {
      color: #1565D8;
    }
  }
  .collapse-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 6px;
    cursor: pointer;
    transition: background 0.15s ease;
    border: none;
    background: transparent;
    padding: 0;
    &:hover {
      background: #F0F2F5;
    }
    svg {
      font-size: 16px;
      color: #86909C;
      transition: color 0.15s ease;
    }
    &:hover svg {
      color: #4E5969;
    }
  }
}

/* Menu scrollable area */
.sidebar-menu-area {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 8px;
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #E8ECF1;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #C9CDD4;
  }
}

/* ProSidebar overrides */
.pro-sidebar {
  width: 100% !important;
  min-width: 100% !important;
  position: relative;
  .pro-sidebar-inner {
    background: transparent !important;
    border: none !important;
  }
}
.pro-sidebar.collapsed {
  width: 100% !important;
  min-width: 100% !important;
}

/* Menu reset */
.pro-sidebar .pro-menu {
  padding: 0 !important;
}
.pro-sidebar .pro-menu > ul {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* Menu items */
.pro-sidebar .pro-menu .pro-menu-item {
  font-size: 13px;
  border: none !important;
  margin: 0;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item {
  padding: 9px 14px !important;
  margin: 0 !important;
  border-radius: 8px;
  background: transparent !important;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
  display: flex;
  align-items: center;
  color: #4E5969 !important;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:hover {
  background: #F2F5FA !important;
  color: #4E5969 !important;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:focus {
  outline: none;
}

/* Icon wrapper */
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  margin-right: ${({ collapsed }) => collapsed ? '0' : '10px'};
  font-size: 18px;
  width: 22px;
  min-width: 22px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent !important;
  img {
    width: 18px;
    height: 18px;
  }
  svg {
    width: 18px;
    height: 18px;
  }
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-icon-wrapper .pro-icon {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}

/* Item content text */
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-item-content {
  flex-grow: 1;
  flex-shrink: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #4E5969;
  font-size: 13.5px;
  font-weight: 500;
  letter-spacing: 0.01em;
  user-select: none;
  padding-left: 0;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-item-content a {
  color: #4E5969;
  text-decoration: none;
}

/* Active state — pill background */
.pro-sidebar .pro-menu .pro-menu-item.active > .pro-inner-item {
  background: #F0F4FF !important;
  box-shadow: inset 2px 0 0 #1565D8;
}
.pro-sidebar .pro-menu .pro-menu-item.active > .pro-inner-item > .pro-item-content {
  color: #1565D8 !important;
  font-weight: 600;
}
li.pro-menu-item.active {
  border: none !important;
  margin: 0 !important;
}

/* SubMenu styling */
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  display: inline-block;
  border-style: solid;
  border-color: #86909C;
  border-width: 0 1.5px 1.5px 0;
  padding: 2.5px;
  vertical-align: middle;
  transition: transform 0.25s ease, border-color 0.15s ease;
  transform: rotate(45deg);
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu.open > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  transform: rotate(-135deg);
  border-color: #1565D8;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item:before {
  display: none;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu.open > .pro-inner-item:before {
  display: none;
}

/* Open submenu parent */
.pro-sub-menu.open > .pro-inner-item {
  background: #F7F9FC !important;
}
.pro-sub-menu.open > .pro-inner-item > .pro-item-content {
  color: #1565D8 !important;
  font-weight: 500;
}
.pro-sub-menu.open > .pro-inner-item .pro-icon svg {
  fill: #1565D8 !important;
}

/* SubMenu items list */
.pro-sidebar .pro-menu > ul > .pro-sub-menu > .pro-inner-list-item {
  background-color: transparent !important;
  padding-left: 0 !important;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item {
  padding-left: 0 !important;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 7px 14px 7px 44px !important;
  border-radius: 8px;
  margin: 1px 0 !important;
  background: transparent !important;
  transition: background 0.15s ease;
  position: relative;
  &:before {
    content: '';
    position: absolute;
    left: 28px;
    top: 0;
    bottom: 0;
    width: 1px;
    background: #E8ECF1;
  }
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item:hover {
  background: #F2F5FA !important;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item > .pro-icon-wrapper {
  display: none;
}

/* Active submenu item */
li.pro-menu-item.submenu-item.active .pro-inner-item {
  background: #F0F4FF !important;
  &:before {
    background: #1565D8 !important;
    width: 2px !important;
  }
}
li.pro-menu-item.submenu-item.active span.pro-item-content {
  color: #1565D8 !important;
  font-weight: 600;
}
li.pro-menu-item.submenu-item .pro-inner-item span {
  color: #4E5969 !important;
  font-size: 13.5px;
}

/* Submenu item positioning */
li.pro-menu-item.pro-sub-menu .submenu-item {
  padding: 0;
  margin-left: 0 !important;
}

/* Slidedown animation */
.react-slidedown {
  transition-property: none;
  transition-duration: 0.2s;
  transition-timing-function: ease-in-out;
  ul {
    padding-top: 4px !important;
    padding-bottom: 4px !important;
  }
}
.react-slidedown.transitioning {
  overflow-y: hidden;
}
.react-slidedown.closed {
  display: none;
}

/* Remove border-bottom separators */
.pro-sidebar .pro-menu .pro-menu-item {
  border-bottom: none !important;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .react-slidedown .pro-menu-item {
  border-bottom: none !important;
}

/* Collapsed state */
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-item > .suffix-wrapper,
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-item > .prefix-wrapper {
  opacity: 0;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item::before {
  content: '';
  display: inline-block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  cursor: pointer;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu {
  position: relative;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-item {
  pointer-events: none;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper {
  display: none;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item {
  height: auto !important;
  position: fixed;
  visibility: hidden;
  background-color: transparent;
  max-height: 100%;
  padding-left: 3px !important;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item > .popper-inner {
  max-height: 100vh;
  overflow-y: auto;
  background: #fff !important;
  padding: 8px !important;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08), 0 1px 4px rgba(0, 0, 0, 0.04);
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu:hover > .pro-inner-list-item {
  transition: visibility 0.2s, transform 0.2s;
  visibility: visible;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-sub-menu-item,
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 12px !important;
  margin: 0 !important;
}
.pro-sidebar.collapsed li.pro-menu-item.pro-sub-menu {
  background: transparent !important;
}
.pro-sidebar.collapsed li.pro-menu-item.pro-sub-menu .submenu-item {
  margin: 0 !important;
}

/* Disable hover animation */
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:hover .pro-icon-wrapper .pro-icon {
  animation: none;
}

/* Profile section */
.sidebar-profile {
  border-top: 1px solid #F0F2F5;
  padding: ${({ collapsed }) => collapsed ? '12px 8px' : '12px 16px'};
  display: flex;
  align-items: center;
  justify-content: ${({ collapsed }) => collapsed ? 'center' : 'flex-start'};
  gap: 10px;
  cursor: pointer;
  background: #ffffff;
  transition: background 0.15s ease;
  &:hover {
    background: #F7F9FC;
  }
  .profile-avatar {
    font-size: 11px;
    font-weight: 700;
    line-height: 1;
    letter-spacing: 0.5px;
    text-align: center;
    border-radius: 8px;
    min-width: 32px;
    width: 32px;
    height: 32px;
    background: linear-gradient(135deg, #1565D8 0%, #1E88E5 100%);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .profile-info {
    overflow: hidden;
  }
  .profile-name {
    font-size: 13px;
    font-weight: 500;
    color: #1B2559;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 130px;
    display: block;
    line-height: 1.3;
  }
  .profile-email {
    font-size: 11px;
    font-weight: 400;
    color: #86909C;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 130px;
    display: block;
    line-height: 1.3;
  }
}


/* Shaped icon override */
.pro-sidebar .pro-menu.shaped .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  background-color: transparent !important;
}

/* RTL support (keep existing) */
.pro-sidebar.rtl .pro-menu .pro-menu-item > .pro-inner-item {
  padding: 8px 12px !important;
}
`;

export const UserPopoverContentWrapper = Styled.div`
width: 150px;
.popover-btn {
    display: flex;
    align-items: center;
    grid-gap: 8px;
    cursor: pointer;
    border: 1px solid #1565D8;
    padding: 4px;
    border-radius: 4px;
    justify-content: center;
    &:hover{
      background: #1565D8;
      p, svg{
        color: #fff;
      }
    }
    p {
    margin: 0;
    font-size: 14px;
    color: #1565D8;
    font-weight: 600;
}
svg {
    font-size: 16px;
    color: #1565D8;
}
}
`

export const Header = Styled.div`
    padding: 9px 16px;
    background: #1565D8;
    color: #fff;
    display: flex;
    justify-content: space-between;
    span.icon-wrapper {
    position: absolute;
    left: ${({collapsed}) => collapsed ? '48px' : '208px'} ;
    top: 50px;
    z-index: 9682;
    background: #1565d8;
    width: 23px;
    height: 23px;
    transition: left ease 0.3s;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 30px;
}
    .logo-page-title {
    display: flex;
    justify-content: space-between;
    width: calc(100% - 217px);
    align-items: center;
    .page-title {
      display: flex;
      align-items:center;
      grid-gap:12px;
      span {
      font-size: 14px;
      font-weight: 400;
      color: #F8FAFB;
      &:not(:last-child){
        color: #DDE3EC80;
      }
}
    }
      .file-upload-section{
        height: 30px;
        width: 56vw;
        display: flex;
        background-color: #FFFFFF73;
        color: black;
        padding: 0px 16px;
        border-radius: 5px;
        grid-gap: 0px;
        align-items: center;
        justify-content: space-around;
        overflow: auto;
          &::-webkit-scrollbar {
            display: none;
          }
        scrollbar-width: none;
        -ms-overflow-style: none;
        .file-info {
          display: flex;
          align-items: center;
          grid-gap: 4px;
            span:nth-of-type(2) {
              max-width: 6vw
            }
          span {
            max-width: 120px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 12px;
            font-weight: 400;
            color: #0000007D;
            &:not(:first-child) {
              font-size: 12px;
              font-weight: 700;
              color: #22413C;
            }
          }
          span.count-cal {
              font-size: 12px;
              color: #fff !important;
              border: 1px solid #FFFFFF;
              width: 32px;
              height: 18px;
              border-radius: 14px;
              display: flex;
              align-items: center;
              justify-content: center;
          }
          .header-bar-placement {
              min-width: 119px;
          }
        }
      }
    .actions {
    display: flex;
    align-items: center;
    grid-gap: 16px;
    .user-title {
      font-size: 10px;
      font-weight: 700;
      line-height: 14px;
      text-align: center;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
      border-radius: 50px;
      width: 30px;
      background: #fff;
      color: #1565D8;
      padding: 8px;
      position: relative;
      cursor: pointer;
      img {
        position: absolute;
        bottom: 0px;
        right: 0px;
      }
    }
.divider {
    width: 1px;
    background: #FFFFFF80;
    height: 22px;
}
}
}
`

const Div = Styled.div``;

const Content = Styled.div`
  padding:12px 24px;
  width:100%;
  height:100%;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 0;
  .collapsed-none{
    transition: all .2s;
  }
`;

export const MobileContent = Styled.div`
padding: 24px;
height: calc(100vh - 65px);
overflow: auto;
`;

export { Div, Content };
